var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-con"},[_c('audio',{ref:"AntAudio",staticClass:"ant-audio",attrs:{"id":"AntAudio","src":_vm.audioSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }